import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';
import { FocusSelectOnDirective } from '../../../directives/focus-select.directive';
import { MaskDirective } from '../../../directives/mask-directive/mask.directive';
import { MaskedDateCellEditorBaseComponent } from '../masked-date-cell-editor-base/masked-date-cell-editor-base.component';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'se-masked-date-cell-editor-popup',
    templateUrl: './masked-date-cell-editor-popup.component.html',
    styleUrls: ['./masked-date-cell-editor-popup.component.scss'],
    imports: [
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        FocusSelectOnDirective,
        MaskDirective,
        TranslateModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MaskedDateCellEditorPopupComponent extends MaskedDateCellEditorBaseComponent {
    readonly width = input.required<string>();
}
